(function() {
	'use strict';
	var unserialize = avm.require('avast.url.unserialize'),
		$body = $('body');

	if (avastGlobals.detect.os.isAndroid) {
		$body.addClass('mobile-detected');
	} else {
		$body.addClass('desktop-detected');
	}

	// Hide Update section for AV Free users
	var params = unserialize(),
		freeParam = params ? params.PRTYPE : null,
		$updateSection = $('#protection');

	if (freeParam === 'AVF'){
		$updateSection.removeClass('hidden');
	}
})();
